export const REQUEST_LOST_ITEMS = 'REQUEST_LOST_ITEMS';
export const REQUEST_LOST_ITEMS_SUCCESS = 'REQUEST_LOST_ITEMS_SUCCESS';
export const REQUEST_LOST_ITEMS_FAILURE = 'REQUEST_LOST_ITEMS_FAILURE';

export const REQUEST_LOST_ITEMS_PRINT = 'REQUEST_LOST_ITEMS_PRINT';
export const REQUEST_LOST_ITEMS_PRINT_SUCCESS = 'REQUEST_LOST_ITEMS_PRINT_SUCCESS';
export const REQUEST_LOST_ITEMS_PRINT_FAILURE = 'REQUEST_LOST_ITEMS_PRINT_FAILURE';

export const REQUEST_LOST_ITEM = 'REQUEST_LOST_ITEM';
export const REQUEST_LOST_ITEM_SUCCESS = 'REQUEST_LOST_ITEM_SUCCESS';
export const REQUEST_LOST_ITEM_FAILURE = 'REQUEST_LOST_ITEM_FAILURE';